import SettingsPage from "@/pages/settings/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/settings")({
    component: SettingsPage,
});
